exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.uk-button-danger {\n  font-size: 15px; }\n\n.edit-service .uk-button {\n  font-size: 15px; }\n\n.uk-form-controls {\n  font-size: 14px; }\n  .uk-form-controls > input[type=checkbox] {\n    margin-top: 10px; }\n  .uk-form-controls .uk-button.uk-button-success:disabled {\n    background: #f5f5f5;\n    color: #999;\n    text-shadow: none;\n    border: solid 1px rgba(0, 0, 0, 0.2); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/services/services-view/service-view.component.scss
// module id = ../../../../../src-admin/app/components/services/services-view/service-view.component.scss
// module chunks = main